/**
 * Хук данных дашборда платформы.
 *
 * TODO(backend): endpoint GET /v1/platform/dashboard ещё не реализован.
 * Пока возвращаем замоканные KPI/алерты, чтобы каркас экрана был наполнен.
 * Когда endpoint появится — заменить тело queryFn на customFetch и убрать мок.
 */
import { useQuery } from '@tanstack/react-query';

export interface DashboardKpi {
  activeTenants: number;
  mrrKopecks: number;
  mrrChangePct: number;
  churnRatePct: number;
  openAlerts: number;
}

export interface DashboardAlert {
  id: string;
  kind: 'subscription_overdue' | 'vendor_queue' | 'job_failure';
  title: string;
  detail: string;
}

export interface DashboardData {
  kpi: DashboardKpi;
  alerts: DashboardAlert[];
}

// MOCK: замоканные данные дашборда (см. TODO выше).
const MOCK_DASHBOARD: DashboardData = {
  kpi: {
    activeTenants: 0,
    mrrKopecks: 0,
    mrrChangePct: 0,
    churnRatePct: 0,
    openAlerts: 0,
  },
  alerts: [],
};

export function useDashboard() {
  return useQuery<DashboardData>({
    queryKey: ['platform', 'dashboard'],
    queryFn: async () => {
      // TODO(backend): return customFetch<DashboardData>({ url: '/platform/dashboard' });
      return Promise.resolve(MOCK_DASHBOARD);
    },
  });
}
